// -----------------------------
// 1) Test data
// -----------------------------
const subjects = [
  // Valid (should match and extract the remainder after the label)
  "Pol num : Renewal of GPNU-PF-0013431-04 check",  // should STOP after token
  "pol num : renewal of GPNU-PF-0013431-04",
  "pol num : GPNU-PF-0013431-04",
  "Pol Number : GPNU.PF.0013431.04",
  "Pol Number : Renewal of GPNU.PF.0013431.04",
  "policy #: AH03-JRH-240000722-",
  "Policy#: 76SBUBL3MRC/76SBUBP2JSX",
  "Policy # ABC123/XYZ456",
  "Policy: ABC123/XYZ456",
  "Policy ABC123/XYZ456",
  "Pol ABC123/XYZ456",
  "Pol : ABC123/XYZ456",
  "Pol #: ABC123/XYZ456",
  "Pol # ABC123/XYZ456",
  "Policy number: ABC123/XYZ456",
  "Policynum: ABC123/XYZ456",
  "Policy Renewal Of ABC123/XYZ456",
  "Policy #: Renewal of ABC123/XYZ456",
  "Policy # Renewal of ABC123/XYZ456",
  "Policy : Renewal of ABC123/XYZ456",
  "Pol Renewal of P100.509.028.7",
  "pol #: Renewal of P100.509.028.7",
  "Pol # Renewal of P100.509.028.7",
  "Pol : Renewal of p100.509.028.7",
  "Policy Number: Renewal of p100.509.028.7",
  "Policynum : Renewal of p100.509.028.7",
  "Pol : Renewal of p100.509.028.7",
  "Pol : Renewal of p100.509.028.7",
  "Pol : Renewal of 1007",
  "Pol : Renewal of p100",

  // Invalid (should be rejected either by extractor or by validator)
  "Pol : Renewals of p100.509.028.7",      // plural => extractor should NOT match
  "Pol : Renewal of p100~509.028@7",       // invalid chars — still extract full token
  "Pol : Renewal of p100509$0287",         // invalid char — still extract full token
  "Pol : Renewal of p100!509028@7",        // invalid chars — still extract full token
  "Pol : Renewals of p100/509.028-7!"      // plural => no match
];


// -----------------------------
// 2) Extractor: capture the FULL text after the label
//    - Labels: Policy/Pol with optional Number/Num (spaced or packed)
//    - Optional delimiters: any combo of ':' or '#' with spaces
//    - Capture the rest of the line (trimmed)
// -----------------------------
const reAfterLabel =
  /(?:^|\b)(?:policy|pol)(?:\s*(?:number|num))?\s*(?:[:#]\s*)*(?!\s*renewals\b)\s*(.+\S)/i;

function extractAfterLabel(text) {
  const m = text.match(reAfterLabel);
  if (!m) return null;

  const remainder = m[1].trim();

  // If it contains "Renewal of", cut right after the next token (whole token = \S+)
  const ren = remainder.match(/\brenewal\b\s+of\s+(\S+)/i);
  if (ren) {
    return `Renewal of ${ren[1]}`;
  }
 
  // Otherwise, return only the FIRST token after the label
  // (This cuts "GPNU-PF-0013431-04 eff 213.23.434" -> "GPNU-PF-0013431-04")
  const firstToken = (remainder.match(/^(\S+)/) || [null, remainder])[1];
  return firstToken;
}


// -----------------------------
// 3) Extract JUST the policy number from the remainder (or directly from text)
//    Strategy:
//    - If the text (or remainder) has "Renewal of <token>", take <token> as \S+ (whole token).
//    - Else, take the first token that looks like a valid policy number shape.
// -----------------------------
const rePolicyAfterRenewalToken = /\brenewal\b\s+of\s+(\S+)/i; // whole token (may include invalid chars)
const reFirstValidToken = /([A-Za-z0-9]+(?:[./-][A-Za-z0-9]+)*[./-]?)/;

function extractPolicyNumberFromRemainder(remainder) {
  if (!remainder) return null;

  const m1 = remainder.match(rePolicyAfterRenewalToken);
  if (m1) return m1[1].trim();  // full token, e.g., "p100!509028@7"

  const m2 = remainder.match(reFirstValidToken);
  if (m2) return m2[1].trim();

  return null;
}


// -----------------------------
// 4) Validator for policy number (unchanged)
//    - Allowed shape: alphanumerics with separators . / -
//    - Optional trailing separator allowed (e.g., ...722-)
//    - Must contain at least one digit OR at least one separator
// -----------------------------
function isValidPolicyNumber(value) {
  if (!value) return false;
  value = value.trim();

  const allowedShape = /^[A-Za-z0-9]+(?:[./-][A-Za-z0-9]+)*[./-]?$/i.test(value);
  const hasDigitOrSeparator = /[0-9./-]/.test(value);

  return allowedShape && hasDigitOrSeparator;
}


// -----------------------------
// 5) Demo runner
// -----------------------------

export const policyNumberCheck = (s) => {
  const remainder = extractAfterLabel(s);
  const policyNo  = extractPolicyNumberFromRemainder(remainder);
  const valid     = isValidPolicyNumber(policyNo);

  const header = `${s}`;
  if (remainder === null) {
    // console.error(`${header}\n  -> after-label: (no match)\n`);
    return null;
  } else if (!policyNo) {
    // console.error(`${header}\n  -> after-label: ${remainder}\n  -> policy no: (none)\n  -> valid: false\n`);
    return null;
  } else if (!valid) {
    // console.error(`${header}\n  -> after-label: ${remainder}\n  -> policy no: ${policyNo}\n  -> valid: false\n`);
    return null;
  } else {
    console.log(`${header}\n  -> after-label: ${remainder}\n  -> policy no: ${policyNo}\n  -> valid: true\n`);
    return remainder;
  }
}
